const css = `.adaptive-select-trigger {
  display: flex;
  align-items: center;
  background: var(--surface-raised);
  border: 1px solid var(--border-strong);
  border-radius: var(--border-radius);
  padding: 0px 12px;
  cursor: pointer;
  position: relative;
  transition: border-color 0.2s;
  color: var(--text-muted);
  font-size: var(--font-size-base);
  overflow: hidden;
  max-height: 48px;
  padding: 12px;
}
.adaptive-select-trigger .user-display,
.adaptive-select-trigger .readonly-form .user-display {
  margin-left: 0;
}
.adaptive-select-trigger.placeholder {
  color: var(--text-subtle);
  font-weight: var(--font-weight-regular);
}
.adaptive-select-trigger.p-invalid {
  border-color: var(--danger);
}
.adaptive-select-trigger.disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.adaptive-select-trigger:not(.disabled):hover {
  border-color: var(--accent);
}
.adaptive-select-trigger:after {
  position: absolute;
  right: 8px;
  z-index: 2;
  font-family: var(--font-family-icons);
  content: "\\e902";
  font-size: var(--font-size-sm);
  color: var(--text-muted);
}
.adaptive-select-trigger:before {
  content: "";
  position: absolute;
  right: 0;
  top: 0;
  width: 32px;
  height: 100%;
  background: var(--surface-raised);
  z-index: 1;
}
.adaptive-select-trigger.is-filter:after, .adaptive-select-trigger.is-filter:before {
  display: none;
}
.adaptive-select-trigger .selected-items {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  padding-right: 32px;
  max-width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
  white-space: nowrap;
}
.adaptive-select-trigger .selected-items::-webkit-scrollbar {
  display: none;
}
.adaptive-select-trigger .selected-items .selected-item {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: var(--font-size-sm);
  position: relative;
}
.adaptive-select-trigger .selected-items .selected-item:not(:last-child)::after {
  content: " ";
  position: absolute;
  right: -7px;
  width: 1px;
  background-color: var(--border-strong);
  height: 60%;
}
.adaptive-select-trigger .selected-items .selected-item .user-display {
  display: flex;
  align-items: center;
  gap: 8px;
}
.adaptive-select-trigger .selected-items .text-items {
  flex-shrink: 0;
  white-space: nowrap;
}
.adaptive-select-trigger .selected-items .text-items span:not(:last-child)::after {
  content: " | ";
  color: var(--text-subtle);
}

.adaptive-select-modal {
  width: 90vw;
  max-height: 80vh;
  max-width: 750px;
}
.adaptive-select-modal .p-dialog-content {
  padding: 0;
  display: flex;
  flex-direction: column;
}
.adaptive-select-modal .adaptive-select-content {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}
.adaptive-select-modal .adaptive-select-content .adaptive-select-search {
  padding-bottom: 12px;
  border-bottom: 1px solid var(--border);
}
.adaptive-select-modal .adaptive-select-content .adaptive-select-search .p-inputtext {
  width: 100%;
}
.adaptive-select-modal .adaptive-select-content .adaptive-select-options {
  flex: 1;
  overflow-y: auto;
  padding: 8px 0;
}
.adaptive-select-modal .adaptive-select-content .adaptive-select-options .select-all-option {
  padding: 12px;
  border-bottom: 1px solid var(--border);
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}
.adaptive-select-modal .adaptive-select-content .adaptive-select-options .select-all-option:hover {
  background-color: var(--surface-sunken);
}
.adaptive-select-modal .adaptive-select-content .adaptive-select-options .adaptive-select-option {
  padding: 12px;
  cursor: pointer;
  transition: background-color 0.2s;
  display: flex;
  align-items: center;
  gap: 8px;
}
.adaptive-select-modal .adaptive-select-content .adaptive-select-options .adaptive-select-option .coupon-display {
  flex-wrap: wrap;
}
.adaptive-select-modal .adaptive-select-content .adaptive-select-options .adaptive-select-option:hover {
  background-color: var(--surface-sunken);
}
.adaptive-select-modal .adaptive-select-content .adaptive-select-options .adaptive-select-option:active {
  background-color: var(--border);
}
.adaptive-select-modal .adaptive-select-content .adaptive-select-options .adaptive-select-option.selected {
  background-color: var(--surface-sunken);
}
.adaptive-select-modal .adaptive-select-content .adaptive-select-options .adaptive-select-empty {
  padding: 12px;
  text-align: center;
  color: var(--text-subtle);
}

@media screen and (max-width: 768px) {
  .adaptive-select-modal .p-dialog-content {
    max-height: calc(80vh - 70px) !important;
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL29wdC9yZW5kZXIvcHJvamVjdC9zcmMvc3JjL2NvbXBvbmVudHMvQWRhcHRpdmVTZWxlY3QiLCJzb3VyY2VzIjpbIkFkYXB0aXZlU2VsZWN0LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFFQTtFQUNBOztBQUVBO0FBQUE7RUFFRTs7QUFHRjtFQUNFO0VBQ0E7O0FBR0Y7RUFDRTs7QUFHRjtFQUNFO0VBQ0E7O0FBR0Y7RUFDRTs7QUFHRjtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBOztBQUdGO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7QUFJQTtFQUVFOztBQUlKO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7QUFFQTtFQUNFOztBQUdGO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBOztBQUVBO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBOztBQUdGO0VBQ0U7RUFDQTtFQUNBOztBQUlKO0VBQ0U7RUFDQTs7QUFFQTtFQUNFO0VBQ0E7OztBQU1SO0VBQ0U7RUFDQTtFQUNBOztBQUVBO0VBQ0U7RUFDQTtFQUNBOztBQUdGO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7O0FBRUE7RUFDRTtFQUNBOztBQUVBO0VBQ0U7O0FBSUo7RUFDRTtFQUNBO0VBQ0E7O0FBRUE7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7O0FBRUE7RUFDRTs7QUFJSjtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7QUFFQTtFQUNFOztBQUdGO0VBQ0U7O0FBR0Y7RUFDRTs7QUFHRjtFQUNFOztBQUlKO0VBQ0U7RUFDQTtFQUNBOzs7QUFNUjtFQUVJO0lBQ0UiLCJzb3VyY2VzQ29udGVudCI6WyIuYWRhcHRpdmUtc2VsZWN0LXRyaWdnZXIge1xuICBkaXNwbGF5OiBmbGV4O1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuICBiYWNrZ3JvdW5kOiB2YXIoLS1zdXJmYWNlLXJhaXNlZCk7XG4gIGJvcmRlcjogMXB4IHNvbGlkIHZhcigtLWJvcmRlci1zdHJvbmcpO1xuICBib3JkZXItcmFkaXVzOiB2YXIoLS1ib3JkZXItcmFkaXVzKTtcbiAgcGFkZGluZzogMHB4IDEycHg7XG4gIGN1cnNvcjogcG9pbnRlcjtcbiAgcG9zaXRpb246IHJlbGF0aXZlO1xuICB0cmFuc2l0aW9uOiBib3JkZXItY29sb3IgMC4ycztcbiAgY29sb3I6IHZhcigtLXRleHQtbXV0ZWQpO1xuICBmb250LXNpemU6IHZhcigtLWZvbnQtc2l6ZS1iYXNlKTtcbiAgb3ZlcmZsb3c6IGhpZGRlbjtcblxuICBtYXgtaGVpZ2h0OiA0OHB4O1xuICBwYWRkaW5nOiAxMnB4O1xuXG4gIC51c2VyLWRpc3BsYXksXG4gIC5yZWFkb25seS1mb3JtIC51c2VyLWRpc3BsYXkge1xuICAgIG1hcmdpbi1sZWZ0OiAwO1xuICB9XG5cbiAgJi5wbGFjZWhvbGRlciB7XG4gICAgY29sb3I6IHZhcigtLXRleHQtc3VidGxlKTtcbiAgICBmb250LXdlaWdodDogdmFyKC0tZm9udC13ZWlnaHQtcmVndWxhcik7XG4gIH1cblxuICAmLnAtaW52YWxpZCB7XG4gICAgYm9yZGVyLWNvbG9yOiB2YXIoLS1kYW5nZXIpO1xuICB9XG5cbiAgJi5kaXNhYmxlZCB7XG4gICAgb3BhY2l0eTogMC42O1xuICAgIGN1cnNvcjogbm90LWFsbG93ZWQ7XG4gIH1cblxuICAmOm5vdCguZGlzYWJsZWQpOmhvdmVyIHtcbiAgICBib3JkZXItY29sb3I6IHZhcigtLWFjY2VudCk7XG4gIH1cblxuICAmOmFmdGVyIHtcbiAgICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gICAgcmlnaHQ6IDhweDtcbiAgICB6LWluZGV4OiAyO1xuICAgIGZvbnQtZmFtaWx5OiB2YXIoLS1mb250LWZhbWlseS1pY29ucyk7XG4gICAgY29udGVudDogJ1xcZTkwMic7XG4gICAgZm9udC1zaXplOiB2YXIoLS1mb250LXNpemUtc20pO1xuICAgIGNvbG9yOiB2YXIoLS10ZXh0LW11dGVkKTtcbiAgfVxuXG4gICY6YmVmb3JlIHtcbiAgICBjb250ZW50OiAnJztcbiAgICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gICAgcmlnaHQ6IDA7XG4gICAgdG9wOiAwO1xuICAgIHdpZHRoOiAzMnB4O1xuICAgIGhlaWdodDogMTAwJTtcbiAgICBiYWNrZ3JvdW5kOiB2YXIoLS1zdXJmYWNlLXJhaXNlZCk7XG4gICAgei1pbmRleDogMTtcbiAgfVxuXG4gICYuaXMtZmlsdGVyIHtcbiAgICAmOmFmdGVyLFxuICAgICY6YmVmb3JlIHtcbiAgICAgIGRpc3BsYXk6IG5vbmU7XG4gICAgfVxuICB9XG5cbiAgLnNlbGVjdGVkLWl0ZW1zIHtcbiAgICBkaXNwbGF5OiBmbGV4O1xuICAgIGZsZXgtZGlyZWN0aW9uOiByb3c7XG4gICAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgICBnYXA6IDEycHg7XG4gICAgcGFkZGluZy1yaWdodDogMzJweDtcbiAgICBtYXgtd2lkdGg6IDEwMCU7XG4gICAgb3ZlcmZsb3cteDogYXV0bztcbiAgICBvdmVyZmxvdy15OiBoaWRkZW47XG4gICAgc2Nyb2xsYmFyLXdpZHRoOiBub25lO1xuICAgIC1tcy1vdmVyZmxvdy1zdHlsZTogbm9uZTtcbiAgICB3aGl0ZS1zcGFjZTogbm93cmFwO1xuXG4gICAgJjo6LXdlYmtpdC1zY3JvbGxiYXIge1xuICAgICAgZGlzcGxheTogbm9uZTtcbiAgICB9XG5cbiAgICAuc2VsZWN0ZWQtaXRlbSB7XG4gICAgICBmbGV4LXNocmluazogMDtcbiAgICAgIGRpc3BsYXk6IGlubGluZS1mbGV4O1xuICAgICAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgICAgIGdhcDogNHB4O1xuICAgICAgZm9udC1zaXplOiB2YXIoLS1mb250LXNpemUtc20pO1xuICAgICAgcG9zaXRpb246IHJlbGF0aXZlO1xuXG4gICAgICAmOm5vdCg6bGFzdC1jaGlsZCk6OmFmdGVyIHtcbiAgICAgICAgY29udGVudDogJyAnO1xuICAgICAgICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gICAgICAgIHJpZ2h0OiAtN3B4O1xuICAgICAgICB3aWR0aDogMXB4O1xuICAgICAgICBiYWNrZ3JvdW5kLWNvbG9yOiB2YXIoLS1ib3JkZXItc3Ryb25nKTtcbiAgICAgICAgaGVpZ2h0OiA2MCU7XG4gICAgICB9XG5cbiAgICAgIC51c2VyLWRpc3BsYXkge1xuICAgICAgICBkaXNwbGF5OiBmbGV4O1xuICAgICAgICBhbGlnbi1pdGVtczogY2VudGVyO1xuICAgICAgICBnYXA6IDhweDtcbiAgICAgIH1cbiAgICB9XG5cbiAgICAudGV4dC1pdGVtcyB7XG4gICAgICBmbGV4LXNocmluazogMDtcbiAgICAgIHdoaXRlLXNwYWNlOiBub3dyYXA7XG5cbiAgICAgIHNwYW46bm90KDpsYXN0LWNoaWxkKTo6YWZ0ZXIge1xuICAgICAgICBjb250ZW50OiAnIHwgJztcbiAgICAgICAgY29sb3I6IHZhcigtLXRleHQtc3VidGxlKTtcbiAgICAgIH1cbiAgICB9XG4gIH1cbn1cblxuLmFkYXB0aXZlLXNlbGVjdC1tb2RhbCB7XG4gIHdpZHRoOiA5MHZ3O1xuICBtYXgtaGVpZ2h0OiA4MHZoO1xuICBtYXgtd2lkdGg6IDc1MHB4O1xuXG4gIC5wLWRpYWxvZy1jb250ZW50IHtcbiAgICBwYWRkaW5nOiAwO1xuICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcbiAgfVxuXG4gIC5hZGFwdGl2ZS1zZWxlY3QtY29udGVudCB7XG4gICAgZGlzcGxheTogZmxleDtcbiAgICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICAgIGhlaWdodDogMTAwJTtcbiAgICBvdmVyZmxvdzogaGlkZGVuO1xuXG4gICAgLmFkYXB0aXZlLXNlbGVjdC1zZWFyY2gge1xuICAgICAgcGFkZGluZy1ib3R0b206IDEycHg7XG4gICAgICBib3JkZXItYm90dG9tOiAxcHggc29saWQgdmFyKC0tYm9yZGVyKTtcblxuICAgICAgLnAtaW5wdXR0ZXh0IHtcbiAgICAgICAgd2lkdGg6IDEwMCU7XG4gICAgICB9XG4gICAgfVxuXG4gICAgLmFkYXB0aXZlLXNlbGVjdC1vcHRpb25zIHtcbiAgICAgIGZsZXg6IDE7XG4gICAgICBvdmVyZmxvdy15OiBhdXRvO1xuICAgICAgcGFkZGluZzogOHB4IDA7XG5cbiAgICAgIC5zZWxlY3QtYWxsLW9wdGlvbiB7XG4gICAgICAgIHBhZGRpbmc6IDEycHg7XG4gICAgICAgIGJvcmRlci1ib3R0b206IDFweCBzb2xpZCB2YXIoLS1ib3JkZXIpO1xuICAgICAgICBkaXNwbGF5OiBmbGV4O1xuICAgICAgICBhbGlnbi1pdGVtczogY2VudGVyO1xuICAgICAgICBnYXA6IDhweDtcbiAgICAgICAgY3Vyc29yOiBwb2ludGVyO1xuXG4gICAgICAgICY6aG92ZXIge1xuICAgICAgICAgIGJhY2tncm91bmQtY29sb3I6IHZhcigtLXN1cmZhY2Utc3Vua2VuKTtcbiAgICAgICAgfVxuICAgICAgfVxuXG4gICAgICAuYWRhcHRpdmUtc2VsZWN0LW9wdGlvbiB7XG4gICAgICAgIHBhZGRpbmc6IDEycHg7XG4gICAgICAgIGN1cnNvcjogcG9pbnRlcjtcbiAgICAgICAgdHJhbnNpdGlvbjogYmFja2dyb3VuZC1jb2xvciAwLjJzO1xuICAgICAgICBkaXNwbGF5OiBmbGV4O1xuICAgICAgICBhbGlnbi1pdGVtczogY2VudGVyO1xuICAgICAgICBnYXA6IDhweDtcblxuICAgICAgICAuY291cG9uLWRpc3BsYXkge1xuICAgICAgICAgIGZsZXgtd3JhcDogd3JhcDtcbiAgICAgICAgfVxuXG4gICAgICAgICY6aG92ZXIge1xuICAgICAgICAgIGJhY2tncm91bmQtY29sb3I6IHZhcigtLXN1cmZhY2Utc3Vua2VuKTtcbiAgICAgICAgfVxuXG4gICAgICAgICY6YWN0aXZlIHtcbiAgICAgICAgICBiYWNrZ3JvdW5kLWNvbG9yOiB2YXIoLS1ib3JkZXIpO1xuICAgICAgICB9XG5cbiAgICAgICAgJi5zZWxlY3RlZCB7XG4gICAgICAgICAgYmFja2dyb3VuZC1jb2xvcjogdmFyKC0tc3VyZmFjZS1zdW5rZW4pO1xuICAgICAgICB9XG4gICAgICB9XG5cbiAgICAgIC5hZGFwdGl2ZS1zZWxlY3QtZW1wdHkge1xuICAgICAgICBwYWRkaW5nOiAxMnB4O1xuICAgICAgICB0ZXh0LWFsaWduOiBjZW50ZXI7XG4gICAgICAgIGNvbG9yOiB2YXIoLS10ZXh0LXN1YnRsZSk7XG4gICAgICB9XG4gICAgfVxuICB9XG59XG5cbkBtZWRpYSBzY3JlZW4gYW5kIChtYXgtd2lkdGg6IDc2OHB4KSB7XG4gIC5hZGFwdGl2ZS1zZWxlY3QtbW9kYWwge1xuICAgIC5wLWRpYWxvZy1jb250ZW50IHtcbiAgICAgIG1heC1oZWlnaHQ6IGNhbGMoODB2aCAtIDcwcHgpICFpbXBvcnRhbnQ7XG4gICAgfVxuICB9XG59XG4iXX0= */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
